import React from 'react';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ScanIcon from '../../assets/images/scans.svg';
import VerifiedIcon from '../../assets/images/verified.svg';
import FailedIcon from '../../assets/images/error-line.svg';

import { ScanStatistics, StatisticInterval } from '../../types/crm';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '18px',
  },
  card: {
    minWidth: '248px',
    boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',

    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,

    width: '100%',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '16px',

    '& div': {
      width: '25%',
    },

    '& div:not(:first-child)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  scanRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '&:not(:last-child)': {
      paddingBottom: '16px',
    },

    '& p': {
      width: '25%',
    },

    '& h3': {
      width: '25%',
      textAlign: 'center',
    },
  },

  empty: {
    display: 'flex',
    width: '32px',
    height: '32px',
    alignItems: 'center',
  },
}));

type CardProps = {
  data?: ScanStatistics;
};

type IntervalProps = {
  interval: StatisticInterval;
};

const IntervalRow: React.FC<IntervalProps> = ({ interval }) => {
  const classes = useStyles();
  const date = interval.from_date ? format(new Date(interval.from_date), 'dd-MMM') : '';

  return (
    <div className={classes.scanRow}>
      <Typography>{date}</Typography>
      <Typography variant="h3">{interval.valid}</Typography>
      <Typography variant="h3">{interval.fails}</Typography>
      <Typography variant="h3">{interval.total}</Typography>
    </div>
  );
};

const DataCard: React.FC<CardProps> = ({ data }) => {
  const classes = useStyles();
  if (!data)
    return (
      <div className={classes.container}>
        <div className={classes.card} />
      </div>
    );

  return (
    <div className={classes.card}>
      <div className={classes.container}>
        <div className={classes.headerRow}>
          <div className={classes.empty}>
            <Typography variant="h6">From</Typography>
          </div>
          <div>
            <img src={VerifiedIcon} alt="Verified" />
          </div>
          <div>
            <img src={FailedIcon} alt="Failed" />
          </div>

          <div>
            <img src={ScanIcon} alt="Scans" />
          </div>
        </div>

        <IntervalRow interval={data.interval_1} />
        <IntervalRow interval={data.interval_2} />
        <IntervalRow interval={data.interval_3} />
      </div>
    </div>
  );
};

export default DataCard;
